import { Text } from "theme-ui";

import { link_error_consumer_facing_copy } from "../lib/link_errors";

export const ErrorText: React.FC<{ error_type: string, error?: string, status?: number }> = ({ error, error_type, status }) => {
  return (
    <Text sx={{ color: "red", fontSize: 1, textAlign: "center" }}>
      {error ?? link_error_consumer_facing_copy(error_type, status)}
    </Text>
  );
};
